<template>
  <div class="progress">
    <div class="progress-bg">
      <!-- <div class="progress-bg-text" v-if="!isFull">{{ `${NumberFormatHanle(cur_kep)}/${NumberFormatHanle(total_kep)}` }}</div> -->
      <!-- <div class="progress-bg-text" v-else>{{ `Full level` }}</div> -->
      <div class="progress-bg-line" 
          :style="{ 
            width: `${!isFull ? `${Math.floor(((cur_kep >= total_kep? total_kep : cur_kep) / total_kep)* 100)}%` : '100%'}`
          }"
      ></div>
    </div>
  </div>
</template>
<script>
import { onBeforeMount, onMounted, ref, computed, nextTick } from "vue";
import _ from "lodash";
import { getTime, NumberFormat } from "@/utils/utils";
import audioManager from "@/utils/audioManager";

export default {
  components: {},
  props: {
    cur_kep: {
      type: Number,
      default: 0,
    },
    total_kep: {
      type: Number,
      default: 0,
    },
    isFull: {
      type: Boolean,
      default: false,
    }
  },
  watch: {
    cur_kep: {
      handler(value) {
        this.curKep = value;
      },
      immediate: true,
      deep: true,
    },
  },

  computed: {
    divWidth: function () {
      const lineWidth = this.progressWidth - this.progressPadding;
      if (this.curKep === 500) {
        const width = "100%";
        return width;
      } else {
        const width =
          (this.curKep / this.total_kep).toFixed(0) + "%";
        return width;
      }
    },
  },
  setup(props, { emit }) {
    const { cur_kep, total_kep } = props;
    const curKep = ref(cur_kep); //保存上一次经验值
    const divWidth = ref(0);
    const progressWidth = ref(0); //移动端适配进度条的宽度
    const progressPadding = ref(0); //进度条的内边距
    const NumberFormatHanle = NumberFormat;
    onMounted(() => {
      nextTick(() => {
        //获取当前机型进度条宽度
        const progress_el = document.querySelector(".progress");
        progressWidth.value = progress_el.offsetWidth;

        //获取当前机型进度条左右内边距
        const bg_el = document.querySelector(".progress-bg");
        progressPadding.value =
          Number(window.getComputedStyle(bg_el).paddingLeft.replace("px", "")) +
          Number(window.getComputedStyle(bg_el).paddingRight.replace("px", ""));
      });
    });

    return {
      progressPadding,
      curKep,
      progressWidth,
      NumberFormatHanle,
    };
  },
};
</script>

<style lang="less" scoped>
.progress {
  width: 100%;
  height: 26px;
  top: 0px;
  left: 0px;
  &-bg {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 15px;
    background: #0E244F;
    border-radius: 3px;
    border: 0.5px solid #0F193B;
    box-sizing: border-box;
    &-text {
      height: 26px;
      position: absolute;
      top: 0px;
      left: 50%;
      transform: translate(-50%, 0);
      color: #fff;
      font-size: 12px;
      font-weight: 500;
      font-family: "PingFang SC";
      text-align: center;
      text-shadow: 0 1px 2px rgba(70, 71, 84, 1), 1px 0 2px rgba(70, 71, 84, 1), -1px 0 2px rgba(70, 71, 84, 1), 0 -1px 2px rgba(70, 71, 84, 1);
    }
    &-line {
      height: 13px;
      background: #57FFEB;
      border-radius: 3px;
      transition: all 1s;
    }
  }
  &-kep {
    position: absolute;
    top: -9.18px;
    left: -10px;
    width: 44px;
    height: 44px;
  }
}
</style>
